var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEventBusy = function SvgEventBusy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0059FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M11.083 20.417a4.667 4.667 0 0 1 4.667-4.667h24.5a4.667 4.667 0 0 1 4.666 4.667V40.25a4.667 4.667 0 0 1-4.666 4.667h-24.5a4.667 4.667 0 0 1-4.667-4.667V20.417Zm7.584-9.333v8.167m18.666-8.167v8.167"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0059FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m22.167 25.666 11.667 11.667m-.001-11.667L22.166 37.333"
  })));
};
export { SvgEventBusy as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuMDgzIDIwLjQxN2E0LjY2NyA0LjY2NyAwIDAgMSA0LjY2Ny00LjY2N2gyNC41YTQuNjY3IDQuNjY3IDAgMCAxIDQuNjY2IDQuNjY3VjQwLjI1YTQuNjY3IDQuNjY3IDAgMCAxLTQuNjY2IDQuNjY3aC0yNC41YTQuNjY3IDQuNjY3IDAgMCAxLTQuNjY3LTQuNjY3VjIwLjQxN1pNMTguNjY3IDExLjA4NHY4LjE2N00zNy4zMzMgMTEuMDg0djguMTY3IiBzdHJva2U9IiMwMDU5RkEiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0ibTIyLjE2NyAyNS42NjYgMTEuNjY3IDExLjY2N00zMy44MzMgMjUuNjY2IDIyLjE2NiAzNy4zMzMiIHN0cm9rZT0iIzAwNTlGQSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";